import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  ACTIVATE,
  DEACTIVATE,
  PENDING,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import DeactivateUserComp from "../../../components/ui_comps/DeactivateUserComp";

function DeactivateModalIndex({ onSuccess }) {
  const [clientDeactivatedList, setClientDeactivatedList] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  const getAllDeactivatedList = () => {
    ApiRequestGet.getAllDeactivatedClientList({
      status: PENDING,
      userId: "",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          setClientDeactivatedList(res.data);
        }
      })
      .catch(() => {});
  };

  const onClickDeactivate = (clientId, status, isCancelled) => {
    if (isCancelled) setLoading1(true);
    else setLoading(true);
    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status,
      isCancelled,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
        setLoading1(false);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        setLoading(false);
        setLoading1(false);
      });
  };
  useEffect(() => {
    getAllDeactivatedList();
  }, []);
  return (
    <div
      style={{
        overflow: "auto",
        maxHeight: 600,
      }}
      className="hide-scroll-bar"
    >
      {clientDeactivatedList &&
        clientDeactivatedList?.map((res, i) => (
          <DeactivateUserComp
            key={i}
            data={res}
            id={i}
            onClickOK={() => {
              onClickDeactivate(res?.userId, DEACTIVATE, false);
              setSelectedId(res?.userId);
            }}
            loading={loading}
            loading1={loading1}
            selectedId={selectedId}
            userId={res?.userId}
            onClickCancel={() => {
              onClickDeactivate(res?.userId, ACTIVATE, true);
              setSelectedId(res?.userId);
            }}
          />
        ))}

      {clientDeactivatedList?.length === 0 && (
        <div
          style={{
            height: 200,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: 12,
            }}
          >
            No requests found
          </p>
        </div>
      )}
    </div>
  );
}

export default DeactivateModalIndex;
